import { Language, Preferences } from '@pt/models';
import { Observable, of } from 'rxjs';

export const getUserPreferencesMock = (): Observable<Preferences> => {
  return of({
    id: 1,
    language: {
      id: 1,
      name: 'English',
      isoCode: 'en',
    },
  });
};

export const getLanguagesMock = (): Observable<Language[]> => {
  return of([
    {
      id: 1,
      name: 'English',
      isoCode: 'en',
    },
    {
      id: 2,
      name: 'Ukrainian',
      isoCode: 'uk',
    },
    {
      id: 1,
      name: 'Russian',
      isoCode: 'ru',
    },
  ]);
};
